import React, { useState, useEffect } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { Button, Modal, ModalBody, ModalFooter, Spinner, Input, FormGroup, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import apiRequest from '../../utils/apiRequest';
import { Breadcrumbs } from '../../AbstractElements';

const Tasks = () => {
  const [tasks, setTasks] = useState([]);
  const [subAdmins, setSubAdmins] = useState([]);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedSubAdmin, setSelectedSubAdmin] = useState('');
  const [taskDescription, setTaskDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.userToken);

  const fetchTasks = async () => {
    try {
      const response = await apiRequest('get', `${process.env.REACT_APP_API_BASE_URL}/admin/getAllTasks`, {}, token);
      setTasks(response.data);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const fetchSubAdmins = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/active-subadmins`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubAdmins(response.data.subAdmins);
    } catch (error) {
      console.error("Error fetching sub-admins:", error);
    }
  };

  useEffect(() => {
    fetchTasks();
    fetchSubAdmins();
  }, []);




  const columns = [
    {
      name: 'Task Description',
      selector: row => row.taskDescription,
      sortable: true,
    },
    {
      name: 'Assigned To',
      selector: row => row.assignedTo ? row.assignedTo.userName : 'Not Assigned',
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
    },

  ];

  return (
    <div>
      <Breadcrumbs mainTitle="Tasks" parent="Dashboard" title="Create Task"/>
      <DataTable
        columns={columns}
        data={tasks}
        pagination
        highlightOnHover
        striped
      />

    
    </div>
  );
};

export default Tasks;

// import React, { useState, useEffect, Fragment } from 'react';
// import axios from 'axios';
// import DataTable from 'react-data-table-component';
// import { Button, Modal, ModalBody, ModalFooter, Spinner, Input } from 'reactstrap';
// import { useSelector } from 'react-redux';
// import { Breadcrumbs } from '../../AbstractElements';
// import apiRequest from '../../utils/apiRequest';

// const Tasks = () => {
//   const [tasks, setTasks] = useState([]);
//   const [subAdmins, setSubAdmins] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [assignModalOpen, setAssignModalOpen] = useState(false);
//   const [selectedTask, setSelectedTask] = useState(null);
//   const [selectedSubAdmin, setSelectedSubAdmin] = useState('');
//   const [loading, setLoading] = useState(false);
//   const token = useSelector((state) => state.auth.userToken);

//   const fetchTasks = async () => {
//     try {
    
//       const response = await apiRequest('get', `${process.env.REACT_APP_API_BASE_URL}/admin/getAllTasks`, {}, token);

//       setTasks(response.data);
//     } catch (error) {
//       console.error("Error fetching tasks:", error);
//     }
//   };

//   const fetchSubAdmins = async () => {
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/active-subadmins`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setSubAdmins(response.data.subAdmins);
//     } catch (error) {
//       console.error("Error fetching sub-admins:", error);
//     }
//   };

//   useEffect(() => {
//     fetchTasks();
//     fetchSubAdmins();
//   }, []);

//   const handleAssignTask = async () => {
//     try {
//       setLoading(true);
//       const data = {
//         orderId: selectedTask.order._id,
//         subAdminId: selectedSubAdmin,
//       };
//       await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/assign`, data, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       fetchTasks();
//       setAssignModalOpen(false);
//     } catch (error) {
//       console.error("Error assigning task:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAssignModal = (task) => {
//     setSelectedTask(task);
//     setAssignModalOpen(true);
//   };

//   const columns = [
//     {
//       name: 'Order Number',
//       selector: (row) => row.order.orderNumber,
//       sortable: true,
//     },
//     {
//       name: 'Order Date',
//       selector: (row) => row.order.orderDate,
//       sortable: true,
//     },
//     {
//       name: 'Assigned Sub-Admin',
//       selector: (row) => row.subAdmin.userName,
//       sortable: true,
//     },
//     {
//       name: 'Task Status',
//       selector: (row) => row.status,
//       sortable: true,
//     },

//   ];

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handlePerRowsChange = async (newPerPage, page) => {
//     setRowsPerPage(newPerPage);
//   };

//   return (
//     <Fragment>
//       <Breadcrumbs mainTitle="Tasks" parent="Dashboard" />
//     <div className="container-fluid">
//       <div className="table-responsive mt-3">
//         <DataTable
//           columns={columns}
//           data={tasks.slice(
//             (currentPage - 1) * rowsPerPage,
//             currentPage * rowsPerPage
//           )}
//           pagination
//           paginationServer
//           paginationTotalRows={tasks.length}
//           onChangePage={handlePageChange}
//           onChangeRowsPerPage={handlePerRowsChange}
//           paginationRowsPerPageOptions={[10, 20, 30]}
//         />
//       </div>

//       {/* Assign Task Modal */}
//       <Modal isOpen={assignModalOpen} toggle={() => setAssignModalOpen(!assignModalOpen)}>
//         <ModalBody>
//           <h5>Select Sub-Admin to Assign Task</h5>
//           <Input
//             type="select"
//             value={selectedSubAdmin}
//             onChange={(e) => setSelectedSubAdmin(e.target.value)}
//           >
//             <option value="">Select Sub-Admin</option>
//             {subAdmins.map((subAdmin) => (
//               <option key={subAdmin._id} value={subAdmin._id}>
//                 {subAdmin?.userName} ({subAdmin.email})
//               </option>
//             ))}
//           </Input>
//         </ModalBody>
//         <ModalFooter>
//           <Button color="secondary" onClick={() => setAssignModalOpen(!assignModalOpen)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={handleAssignTask} disabled={!selectedSubAdmin}>
//             {loading ? <Spinner size="sm" /> : 'Assign Task'}
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </div>
//     </Fragment>

//   );
// };

// export default Tasks;
